import { Checkbox } from "@graffer-inc/console-design-kit";
import React from "react";
import type { InputProps, PathProps } from "./types";

type Props = InputProps & PathProps & { value: boolean };

export const ProcedureAcceptAppByMailInput: React.FC<Props> = ({
  value,
  disabled = false,
  onChange,
  basePath,
}) => {
  return (
    <div className="field mb-6">
      <Checkbox
        label={"郵送申請可否"}
        description={"手続きを郵送申請で受け付ける場合、チェックをつけます。"}
        options={[
          {
            value: "procedureAcceptAppByMail",
            name: "郵送申請を受け付ける",
          },
        ]}
        disabled={disabled}
        values={value ? ["procedureAcceptAppByMail"] : []}
        onChange={(event) => {
          onChange(basePath, event.target.checked);
        }}
      />
    </div>
  );
};
